const SUPPORTED_PHONE_CHARS = /^\+?[0-9\s\-().]+$/;

export const CRM_SMS_DISABLED_VALIDATION_MESSAGE = 'Send From Text Message is required for CRM agencies';
export const CRM_TEXT_NUMBER_INVALID_VALIDATION_MESSAGE = 'Send From Text Message must be a valid US phone number';

export const isMissingAgencyTextNumber = (phone?: string): boolean => !phone || !phone.trim();

export const isValidAgencyTextNumber = (phone?: string): boolean => {
  if (isMissingAgencyTextNumber(phone)) {
    return false;
  }

  const raw = phone.trim();
  if (!raw || !SUPPORTED_PHONE_CHARS.test(raw)) {
    return false;
  }

  const digits = raw.replace(/\D/g, '');

  if (raw.startsWith('+')) {
    return digits.length === 11 && digits.startsWith('1');
  }

  return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
};
